import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { IRawTimeOccurrenceDatatype } from '../datastore/time/data_types';

function loadTimesCommandCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  QueryMediator: IQueryMediator,
  addRawTimesCommand: any
) {
  return defineCommand(
    'loadTimesCommandCommand',
    function loadTimesCommand(deferred: ng.IDeferred<any>, rawTimeOccurrenceData: IRawTimeOccurrenceDatatype[]) {
      addRawTimesCommand(rawTimeOccurrenceData).then(() => {
        QueryMediator.runQueries(ngTimeOccurrenceDataSource);
        deferred.resolve(ngTimeOccurrenceDataSource);
      });
    }
  );
}

angular.module('ui-ng-calendar').factory('loadTimesCommand', loadTimesCommandCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/load_time.ts